import { chakra, Text as CkText, Box as CkBox } from '@chakra-ui/react'
import styled from '@emotion/styled'
import L from 'leaflet'
import { Popup as PopupModule } from 'react-leaflet'

export const MarkerText = chakra(CkText, {
  baseStyle: () => ({
    fontSize: 'sm',
    lineHeight: '20px',
    fontWeight: 700,
    color: '#fff'
  })
})

export const MarkerWrapper = chakra(CkBox, {
  baseStyle: () => ({
    width: 320
  })
})

export const Popup = styled(PopupModule)`
  .leaflet-popup-content-wrapper {
    background: transparent;
    box-shadow: none;
  }

  .leaflet-popup-content {
    margin-left: 5px;
  }

  .leaflet-popup-tip-container {
    display: none;
  }
`

export const createClusterCustomBlackMarker = function (): any {
  return L.divIcon({
    html: `<span><svg width="150" height="150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect rx="4" ry="4" width="69" height="36" style="fill:#242E2E;stroke:white;stroke-width:1">
    </rect>
    </svg>
    </span>`,
    className: 'leaflet-marker',
    iconSize: L.point(71, 15, false)
  })
}

export const createClusterCustomTealMarker = function (): any {
  return L.divIcon({
    html: `<span><svg width="150" height="150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect rx="4" ry="4" width=  "69" height="36" style="fill:#319795;stroke:white;stroke-width:1">
    </rect>
    </svg>
    </span>`,
    className: 'leaflet-selected-marker',
    iconSize: L.point(71, 15, false)
  })
}
